import {MemberGroup} from "../../ClientManagement/models/InvestorGroupType";
import {NavItem} from "../components/FormNav/NavItem";
import {NavItemType} from "../components/FormNav/NavItemType";
import {Trustee} from "../model/EstateFlowchartTypes";
import {getFamilyMemberByMemberId} from "../utils/DefUtils";
import FormPages from "./FormPages";

export const IRREV_TRUST_BASE_URL = "/Profile/${id}/ClientProfile/EstateFlowchart/${flowchartId}/IrrevocableTrust/${estateItemId}/";

export const IrrevocableTrustFormPages: NavItem[] = [
    {
        id: FormPages.BASIC_INFORMATION.id,
        displayName: FormPages.BASIC_INFORMATION.displayName,
        type: NavItemType.PAGE,
        index: 0,
        pathTemplate: IRREV_TRUST_BASE_URL + FormPages.BASIC_INFORMATION.id
    }
]

export const BENEFICIARIES_AT_MEMBERS_DEATH = (member: Trustee | undefined | null, rawFamilyMembers: MemberGroup, releaseToggles?: { enableEstateFlowchartMVPRelease?: boolean }
) => {
    let firstDeathMember: any = getFamilyMemberByMemberId(member?.memberId, rawFamilyMembers);
    let fullName: string | undefined = firstDeathMember ? firstDeathMember?.firstName + " " + firstDeathMember?.lastName : undefined;
    if (!firstDeathMember && releaseToggles?.enableEstateFlowchartMVPRelease) {
        fullName = member?.customName
    }
    const firstDeathMemberDisplayValue = fullName !== undefined ?
        `Beneficiaries at ${fullName}'s Death` :
        FormPages.BENEFICIARIES_AT_FIRST_DEATH.displayName;

    return {
        id: FormPages.BENEFICIARIES_AT_FIRST_DEATH.id,
        displayName: firstDeathMemberDisplayValue,
        type: NavItemType.PAGE,
        index: 1,
        pathTemplate: IRREV_TRUST_BASE_URL + FormPages.BENEFICIARIES_AT_FIRST_DEATH.id
    }
}